<script setup lang="ts">
const { t } = useI18n({ useScope: "local" });
const props = defineProps<{ id: string }>();

const { field } = useInlineBlockEditor(props.id);

const tickCount = field<number>("tickCount", 5);
const label = field<string>("label", "");
const tickFormat = field<string>("tickFormat", "");
</script>

<template>
  <EditorSection :title="t('title')" icon="lucide:axis-3d" accent="reporting">
    <EditorField :label="t('labelLabel')">
      <Input v-model="label" class="h-8 rounded-sm bg-muted text-[13px]" />
    </EditorField>

    <EditorField :label="t('tickCountLabel')">
      <Input v-model.number="tickCount" type="number" min="0" class="h-8 rounded-sm bg-muted text-[13px]" />
    </EditorField>

    <EditorField :label="t('tickFormatLabel')" :hint="t('tickFormatHint')">
      <Textarea v-model="tickFormat" rows="5" class="rounded-sm bg-muted font-mono text-[12px]" placeholder="(value) => String(value)" />
    </EditorField>
  </EditorSection>
</template>

<i18n lang="yaml">
en:
  title: "X Axis"
  labelLabel: "Label"
  tickCountLabel: "Tick Count"
  tickFormatLabel: "Tick Format"
  tickFormatHint: "Optional JavaScript formatter function for axis tick values."
</i18n>
